import * as React from 'react';
import './index.css';
import { withTranslation } from '@sailor/i18n-mach-pro';
import { GoodDetailMinPrice } from '@/src/pages/shop/c_shop_golden/component';
import { SOURCE_MULTI_SKU_NUM } from '@/components/MultiSkuModalGolden/constant';
import { reportCodeTryException } from '@/src/common/exception';
import getCurrencySymbol from '../../../../utils/getCurrencySymbol';

const Intl = Mach.requireModule('Intl');

interface IProps {
  totalPrice: { //价格对象
    originPrice: GoodDetailMinPrice;
    discountPrice: GoodDetailMinPrice;
    currency: string;
  };
  ready: boolean;
  clickAddBtn: VoidFunction;
  btnText?: string;
  showPrice: boolean;
  source?: number;

  lxClickMv: VoidFunction;
}

class SubmitBtn extends React.Component<any> {
  shouldComponentUpdate(nextProps: Readonly<IProps>): boolean {
    if (this.props.totalPrice !== nextProps.totalPrice || this.props.ready !== nextProps.ready) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    return (
      <view>
        {this.renderBtn()}
      </view>
    );
  }

  // 渲染结算按钮
  renderBtn = () => {
    const { source } = this.props;
    if (source === SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW || source === SOURCE_MULTI_SKU_NUM.SHOP_CART_POPUP) {
      return this._renderNormalBtn();
    } else {
      // 一口价、919活动落地页，其它活动类型落地页
      return this._renderFixedPriceBtn();
    }
  }

  _renderNormalBtn = () => {
    const {
      totalPrice, ready, clickAddBtn, btnText, showPrice,
    } = this.props;
    const color = '#222222';
    const backgroundColor = '#FFE41F';
    const showOrigin = totalPrice.originPrice.amount > totalPrice.discountPrice?.amount;
    return (
      <view
        className="add-food-btn"
        style={{ backgroundColor }}
        onClick={clickAddBtn}
      >
        <text
          className="add-btn-text"
          style={{ color }}
          content={btnText}
        />

        {showPrice && (
          <view className="total-container">
            <text
              className="add-btn-price-text"
              style={{ color }}
              content={totalPrice.discountPrice?.displayText}
            />
            {showOrigin && (
              <text
                className="add-btn-origin-price-text"
                style={{ color: ready ? '#222222' : '#1F1F1F' }}
                content={totalPrice.originPrice.displayText}
              />
            ) }
          </view>
        )}
      </view>
    );
  }

  _renderFixedPriceBtn = () => {
    const {
      totalPrice, clickAddBtn, t, source, lxClickMv
    } = this.props;
    const displayOriginAmount = totalPrice.originPrice.displayText;
    const orderText = source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE ? t('fixprice_cart_2')
      : source === SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE ? t('mkt_promo_guigecheckoutbutton')
        : t('landingpage_guige_checkout_button');
    const { displayText } = totalPrice.discountPrice;
    const richText = displayText ? this.getPriceRichText(totalPrice.discountPrice) : undefined;
    // const leftWidth = Mach.env.screenWidth  - 170;
    const showOrigin = totalPrice.originPrice.amount > totalPrice.discountPrice?.amount;

    // 曝光
    if (lxClickMv) {
      lxClickMv();
    }

    return (
      <view
        className="add-food-btn-fixed"
      >
        <view className="fixed-price-left-part-view">
          <view className="left-price-part">
            {richText && <rich-text className="rich-text-price" content={richText} />}
            {showOrigin
                            && <text className="fixed-price-origin-price" content={`${displayOriginAmount}`} />}
          </view>
        </view>
        <view className="fixed-price-right-part-view" style={{ backgroundColor: '#FFE41F' }} onClick={clickAddBtn}>
          <text
            style={{ color: '#222222' }}
            className="fixed-price-btn-text"
            content={orderText}
          />
        </view>
      </view>
    );
  }

  getPriceRichText = (price: any) => {
    if (!price) return [];
    const { displayAmount, currency, currencySign } = price;
    let currencyText = getCurrencySymbol({ currency });
    if (currencySign) {
      currencyText = currencySign;
    }
    try {
      const amountArr = displayAmount.split('.') || [];
      const integer = amountArr?.[0];
      const decimal = amountArr?.[1] || '00';
      // 文本处理严格左对齐 当遇到RTL情况时会完全反转 更容易控制
      const richText = [

        {
          type: 'text',
          text: integer,
          color: '#222222',
          fontSize: 28,
          fontFamily: 'KeeTa-Bold',
          fontWeight: 700,
        },
        {
          type: 'text',
          text: `.${decimal}`,
          color: '#222222',
          fontSize: 14,
          fontWeight: 700,
          fontFamily: 'KeeTa-Bold',
        },
      ];

      // ios与安卓使用unicodeltr或unicodertl表现完全不一致
      // 这种方式处理对齐最统一
      const isRTL = Intl.isRTL?.() ?? false;
      richText[isRTL ? 'push' : 'unshift']({
        type: 'text',
        text: currencyText,
        color: '#222222',
        fontSize: 14,
        fontFamily: 'KeeTa-Bold',
        fontWeight: 700,
      });
      return richText;
    } catch (error) {
      console.log('[getPriceRichText error]:', error);
      // 捕获到异常上报
      reportCodeTryException({
        message: 'getPriceRich',
        extra: error
      });
      return [];
    }
  };
}

export default withTranslation('', {
  withRef: true,
})(SubmitBtn);
